import React from "react";
import {
  faXTwitter,
  faFacebook,
  faLine,
} from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./ShareButtons.css";

export default function ShareButtons({ title }) {
  const url = window.location.href;
  const encodedURL = encodeURIComponent(url);
  const encodedTitle = encodeURIComponent(title);

  return (
    <div className="share-buttons">
      <p>この記事をシェアする</p>
      <a
        href={`https://x.com/intent/post?text=${encodedTitle}&url=${encodedURL}`}
        target="_blank"
        rel="noopener noreferrer"
        className="share-btn twitter"
      >
        <FontAwesomeIcon icon={faXTwitter} /> X
      </a>
      <a
        href={`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`}
        target="_blank"
        rel="noopener noreferrer"
        className="share-btn facebook"
      >
        <FontAwesomeIcon icon={faFacebook} /> Facebook
      </a>
      <a
        href={`https://social-plugins.line.me/lineit/share?url=${encodedURL}`}
        target="_blank"
        rel="noopener noreferrer"
        className="share-btn line"
      >
        <FontAwesomeIcon icon={faLine} /> LINE
      </a>
    </div>
  );
}